module.exports = __webpack_public_path__ + "media/images/pages/ic-instagram-3c78eaffcfe66c183d59fcc2e26d766d.png";